<template>
    <div v-bind:class="{ 'text-danger': time < 60 }">
        {{ timeHuman }}
    </div>
</template>

<script>
    import moment from 'moment'
    import 'moment-duration-format'
    export default {
        props: {
            time: Number,
        },
        data: function () {
            return {
                timeHuman: '',
            }
        },
        mounted() {
            const setHumanFormat = () => {
                this.timeHuman = moment.duration(this.time, "seconds").format("m [min], s [sec]")
                if (this.time === 0) {
                    return
                }
                this.time -= 1
            }
            setInterval(setHumanFormat, 1000)
            setHumanFormat()
        },
        methods: {

        }
    }
</script>
